// 豆趣拼豆：转换页的轻量 UI 增强（步骤条 / 色板折叠 / 更多设置）。不改任何转换逻辑。
const $ = (id) => document.getElementById(id);
const steps = $('dqSteps');
const done = new Set();
let picked = false;
let downloaded = false;

function refreshSteps() {
  const hasImage = $('fileMeta') && !$('fileMeta').hidden;
  const ready = $('patternReadyBar') && !$('patternReadyBar').hidden;
  done.clear();
  if (hasImage) done.add(1);
  if (hasImage && (picked || ready)) done.add(2);
  if (ready) done.add(3);
  if (ready && downloaded) done.add(4);
  let now = 1;
  while (done.has(now) && now < 4) now += 1;
  steps?.querySelectorAll('[data-step]').forEach((li) => {
    const n = Number(li.dataset.step);
    li.classList.toggle('is-done', done.has(n));
    li.classList.toggle('is-now', n === now && !done.has(n));
  });
  document.body.classList.toggle('dq-has-pattern', ready);
  updateSummary(ready);
  wasReady = ready;
}
let wasReady = false;

// 结果小结卡（价格为示例估算：按 ¥9.9 / 1000 颗、+30% 损耗余量）
function updateSummary(ready) {
  const box = $('dqSummary');
  if (!box) return;
  box.hidden = !ready;
  if (!ready) return;
  const beads = Number(($('totalBeads')?.textContent || '0').replace(/[^\d]/g, '')) || 0;
  $('dqSumSize').textContent = ($('statusSize')?.textContent || '—').replace(/\s/g, '');
  $('dqSumColors').textContent = `${$('usedColors')?.textContent || '—'} 色`;
  $('dqSumBeads').textContent = `${beads.toLocaleString('zh-CN')} 颗`;
  const lo = Math.max(1, beads * 9.9 / 1000), hi = lo * 1.3 + 5;
  $('dqSumPrice').textContent = `¥${Math.round(lo)}–${Math.round(hi)}`;
}

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// 生成中：点阵加载（监听上游 aria-busy）
const shell = document.querySelector('.app-shell');
if (shell) new MutationObserver(() => { const l = $('dqLoading'); if (l) l.hidden = shell.getAttribute('aria-busy') !== 'true'; }).observe(shell, { attributes: true, attributeFilter: ['aria-busy'] });
['totalBeads', 'usedColors', 'statusSize'].forEach((id) => { const el = $(id); if (el) new MutationObserver(() => updateSummary(!$('patternReadyBar')?.hidden)).observe(el, { childList: true, characterData: true, subtree: true }); });

$('dqDownloadBtn')?.addEventListener('click', () => { downloaded = true; $('topExportBtn')?.click(); refreshSteps(); });
const touchBtn = $('dqTouchEdit');
touchBtn?.addEventListener('click', () => {
  const on = touchBtn.getAttribute('aria-pressed') !== 'true';
  touchBtn.setAttribute('aria-pressed', String(on));
  touchBtn.textContent = on ? '绘制' : '拖动';
  window.dqSetTouchEdit?.(on);
});
// 风格卡：选中项滚到可视区（手机横滑时）
document.addEventListener('click', (e) => { const c = e.target.closest('.douqu-preset-btn'); if (c) c.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); });

const mo = new MutationObserver(refreshSteps);
['fileMeta', 'patternReadyBar'].forEach((id) => { const el = $(id); if (el) mo.observe(el, { attributes: true, attributeFilter: ['hidden'] }); });

document.addEventListener('click', (event) => {
  const t = event.target.closest('button, li');
  if (!t) return;
  if (t.closest('#douquPresetGrid') || t.id === 'douquPresetApplyBtn' || t.closest('#douquBatchGrid')) { picked = true; refreshSteps(); }
  if (['topExportBtn', 'readyExportBtn', 'exportPngBtn', 'douquBatchExportBtn'].includes(t.id)) { downloaded = true; refreshSteps(); }
  if (t.dataset && t.dataset.step) {
    const n = Number(t.dataset.step);
    if (n === 1) $('imageInput')?.click();
    if (n === 2) $('douquPresetPanel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (n === 3) $('canvasViewport')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (n === 4) $('topExportBtn')?.click();
  }
  const mt = t.dataset && t.dataset.mobileTarget;
  if (mt === 'sizeSection' && $('dqMore')) $('dqMore').open = true;
});
steps?.querySelectorAll('[data-step]').forEach((li) => { li.tabIndex = 0; li.setAttribute('role', 'button'); });

const toggle = $('dqPaletteToggle');
toggle?.addEventListener('click', () => {
  const open = !document.body.classList.contains('dq-palette-open');
  document.body.classList.toggle('dq-palette-open', open);
  toggle.setAttribute('aria-pressed', String(open));
  window.dispatchEvent(new Event('resize'));
});

refreshSteps();
